import React from 'react';
import { Tooltip } from 'antd';
import { TooltipPlacement } from 'antd/es/tooltip';

interface TooltipProps {
  text: string;
  placement?: TooltipPlacement;
  arrow?: boolean;
  children?: React.ReactNode;
  showText?: boolean;
}

const TooltipLayoutComponent = ({
  text,
  placement = 'topLeft',
  arrow,
  children,
  showText = true,
}: TooltipProps) => {
  return (
    <Tooltip
      placement={placement}
      title={text}
      destroyTooltipOnHide={true}
      overlayInnerStyle={{
        color: 'black',
        width: 'max-content',
        maxWidth: '800px',
        boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.5)',
      }}
      color="rgb(250 250 250)"
      arrow={arrow}
    >
      {showText ? text : children}
    </Tooltip>
  );
};

export default TooltipLayoutComponent;
